import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Banner, Flex, Text } from '@optiaxiom/react';

import { HOME_URL } from '@frontend/envConfig';

type AccessDeniedProps = {
  errorMessage?: string;
  clear?: boolean;
  unauthorized?: boolean;
};

function AccessDenied({ errorMessage, clear, unauthorized }: AccessDeniedProps) {
  const { oktaAuth } = useOktaAuth();
  useEffect(() => {
    const timer = setTimeout(() => {
      if (clear) {
        if (unauthorized) {
          oktaAuth.tokenManager.clear();
          oktaAuth.authStateManager.updateAuthState();
        } else {
          window.location.href = HOME_URL;
        }
      }
    }, 3000);

    return () => clearTimeout(timer);
  });

  return (
    <Flex justifyContent="center" alignItems="center" h="full">
      <Banner intent="danger">
        <Text>{errorMessage || 'You are not authorized to access this page'}</Text>
        {clear && <Text>Redirecting to homepage ...</Text>}
      </Banner>
    </Flex>
  );
}

export default AccessDenied;
